// Porta leve para `src/app` e `src/routes` (JS inicial): manifestos, schemas de busca, catálogo e o
// carregador das telas. Outro módulo usa a `public.ts`.
export { loadBankAccountMessages } from './bank-account.catalog';
export { bankAccountDetailScreen, bankAccountListScreen, transitoryAccountScreen } from './bank-account.screen';
export { bankAccountPixKeysScreen } from './pix.screen';
export {
  AUTOMATIC_PIX_SCREENS,
  bankAccountAutomaticPixActiveScreen,
  bankAccountAutomaticPixHistoryScreen,
  bankAccountAutomaticPixPaidScreen,
  bankAccountAutomaticPixPendingScreen,
  bankAccountAutomaticPixScheduledScreen,
  bankAccountAutomaticPixScreen,
} from './automatic-pix.screen';
export { automaticPixHistorySearch, automaticPixListSearch } from './automatic-pix.search';
export { BANK_ACCOUNT_LIST_PATH, bankAccountDetailSearch, bankAccountListSearch, LEGACY_TAB_SEGMENTS, type BankAccountTab } from './bank-account.search';

/** As telas, carregadas sob demanda pela rota (`lazyScreen`). */
export const loadBankAccountScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadBankAccountGuides = () => import('./bank-account.guide');

export { ACCOUNT_MED_SCREENS, accountMedSearch, bankAccountMedScreen, bankAccountMedContestScreen, bankAccountMedConsultScreen, bankAccountMedInformationScreen } from './account-med.screen';
